import { useLanguage } from "@/lib/i18n/LanguageContext";
import type { ContentSearchStatus } from "@/stores/documents/repository";

/**
 * Says when a search's text matches are incomplete, so a failed or truncated
 * content search does not read as "nothing else matches".
 */
export function DocumentSearchStatusNotice({ status }: { status: ContentSearchStatus }) {
  const { t } = useLanguage();
  const message = status.contentUnavailable
    ? t.documents.search.contentUnavailable
    : status.isPartial
      ? t.documents.search.contentPartial
      : null;
  if (!message) return null;
  return (
    <div
      role="status"
      className="rounded-md border border-border bg-muted/30 px-3 py-2 text-sm text-muted-foreground"
    >
      {message}
    </div>
  );
}
